import { Component, type ErrorInfo, type ReactNode } from 'react';
import { GlobalErrorFallback } from '@/components/GlobalErrorFallback';
import { recordSupportError } from '@/lib/supportDiagnostics';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/** React error boundary without loading Sentry until Analytics consent. */
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    recordSupportError({
      message: error.message,
      stack: error.stack,
      source: 'AppErrorBoundary',
    });
    if (import.meta.env.DEV) {
      console.error('[AppErrorBoundary]', error, info.componentStack);
    }
  }

  render() {
    if (this.state.error) {
      return (
        <GlobalErrorFallback
          error={this.state.error}
          resetError={() => this.setState({ error: null })}
        />
      );
    }
    return this.props.children;
  }
}
